import { FormApi } from 'final-form'
import React, { useEffect, useRef } from 'react'
import { Col, Row } from 'react-bootstrap'

import Button from '../../../../1stlog-ui/src/components/Button'
import Field, {
  required,
  useField,
} from '../../../../1stlog-ui/src/components/Field'
import Input from '../../../../1stlog-ui/src/components/Input'
import { usePrevious } from '../../../../1stlog-ui/src/hooks'

type TProps = {
  form: FormApi
  isLoading: boolean
}

const Form = (props: TProps): React.ReactElement => {
  const { form, isLoading } = props

  const showPassword = useField('showPassword')

  const refInputShort = useRef<HTMLInputElement>()
  const refInputPassword = useRef<HTMLInputElement>()

  const back = (): void => {
    form.batch(() => {
      form.change('showPassword', false)
      form.change('password', '')
    })
  }

  const focusShortInput = (): void => {
    try {
      if (!refInputShort.current) return
      refInputShort.current.focus()
      refInputShort.current.select()
    } catch (err) {
      //
    }
  }

  const focusPasswordInput = (): void => {
    try {
      if (!refInputPassword.current) return
      refInputPassword.current.focus()
      refInputPassword.current.select()
    } catch (err) {
      //
    }
  }

  const previousIsLoading = usePrevious(isLoading)
  useEffect(() => {
    if (previousIsLoading && !isLoading) {
      focusShortInput()
      focusPasswordInput()
    }
  }, [previousIsLoading])

  useEffect(() => {
    if (showPassword) {
      focusPasswordInput()
    } else {
      focusShortInput()
    }
  }, [showPassword])

  const onKeyPress = (e): void => {
    if (e.key === 'Enter') {
      form.submit()
    }
  }

  return (
    <>
      <Row className="text-center">
        <Col>
          <h3>{i18n.t('retourenreceiver', 'Retourenempfänger')}</h3>
        </Col>
      </Row>
      <Row className="text-center">
        <Col>
          {showPassword ? (
            <p>
              {i18n.t(
                'retourenreceiver_password_desc',
                'Bitte tragen Sie das Passwort Ihres Retourenempfängers ein',
              )}
            </p>
          ) : (
            <p>
              {i18n.t(
                'retourenreceiver_desc',
                'Bitte tragen Sie das Kürzel Ihres Retourenempfängers ein',
              )}
            </p>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="d-flex">
            <div className="flex-fill">
              <Field
                name="shortcode"
                validate={required}
                noLabel
                hidden={showPassword}
              >
                <Input
                  innerRef={refInputShort}
                  lg
                  placeholder={i18n.t('enter_short', 'Kürzel eingeben')}
                  onKeyUp={onKeyPress}
                  autoFocus
                />
              </Field>
              {showPassword && (
                <Field name="password" validate={required} noLabel>
                  <Input
                    innerRef={refInputPassword}
                    lg
                    placeholder={i18n.t('enter_password', 'Passwort eingeben')}
                    onKeyUp={onKeyPress}
                    autoFocus
                  />
                </Field>
              )}
            </div>
            {showPassword && (
              <div className="ml-2">
                <Button disabled={isLoading} lg onClick={back}>
                  {i18n.t('btn_back', 'Zurück')}
                </Button>
              </div>
            )}
            <div className="ml-2">
              <Button
                isLoading={isLoading}
                primary
                lg
                disabled={isLoading}
                onClick={form.submit}
              >
                {i18n.t('signin', 'Anmelden')}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Form
